import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import Field from "@/components/Field";
import FormDialog from "@/components/FormDialog";
import { updateBrickSeries } from "../../utils";

interface Props {
  organization: string;
  id: string;
  currentName: string;
  open: boolean;
  onClose(renamed: boolean): void;
}

const EditNameModal: React.FC<Props> = ({ open, organization, id, currentName, onClose }) => {
  const [name, setName] = useState(currentName);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      setName(currentName);
      setError(null);
    }
  }, [open, currentName]);

  const handleSubmit = async () => {
    setSubmitting(true);
    setError(null);
    try {
      await updateBrickSeries(organization, id, { name: name.trim() });
      onClose(true);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <FormDialog
      open={open}
      onOpenChange={(next) => !next && onClose(false)}
      title="Naam wijzigen"
      submitLabel="Opslaan"
      submitting={submitting}
      canSubmit={name.trim() !== "" && name.trim() !== currentName}
      error={error}
      onSubmit={handleSubmit}
    >
      <Field id="series-rename" label="Naam">
        <Input id="series-rename" value={name} onChange={(e) => setName(e.target.value)} />
      </Field>
    </FormDialog>
  );
};

export default EditNameModal;
